// "מצבים ועמודות" — an existing list's states and columns, edited. Saving reconciles on the
// server: kept rows keep their ids (so every row's state and value stay put), new ones
// are added, removed ones dropped — and a state that still holds rows is refused there.
import { useState } from 'react';
import he from '../../i18n/he';
import Modal from '../Modal';
import AsyncBoundary, { ErrorText } from '../Loader';
import useAsync from '../../hooks/useAsync';
import { taskListsApi } from '../../api';
import ListSetup from './ListSetup';
import { definitionFromList, toPayload, isComplete } from './shapes';

// Opened from the panel, which already holds the list, or from the task dialog, which
// holds only its strip — so a missing list is read here first.
export default function DefinitionModal({ taskId, list, onClose, onSaved }) {
  const { data, loading, error } = useAsync(
    () => (list ? Promise.resolve({ list }) : taskListsApi.get(taskId)),
    [taskId],
  );
  return (
    <AsyncBoundary loading={loading} error={error}>
      {data && <DefinitionForm taskId={taskId} list={data.list} onClose={onClose} onSaved={onSaved} />}
    </AsyncBoundary>
  );
}

function DefinitionForm({ taskId, list, onClose, onSaved }) {
  const [def, setDef] = useState(() => definitionFromList(list));
  const [error, setError] = useState(null);

  const save = async () => {
    setError(null);
    try {
      await taskListsApi.define(taskId, toPayload(def));
      onSaved();
    } catch (e) {
      setError(e);
    }
  };

  return (
    <Modal title={he.lists.definition} onClose={onClose} onSave={save} saveDisabled={!isComplete(def)}>
      <ListSetup value={def} onChange={setDef} />
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
